exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.popup-success button.button-style-5[data-v-dbca298e] {\n    margin-left: 10px;\n}\n", ""]);

// exports
